import { type UseQueryResult, useQuery } from "@tanstack/react-query";
import { useNotificationCenterRightOptional } from "web_myplann/Api/Rights/RightsProvider";
import {
	getNotificationCenterSettingsV2,
	type SettingsResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponseQuery } from "web_myplann/Infrastructure/Api/ApiUtils";
import { NotificationSettingsKeys } from "web_myplann/More/NotificationSettings/Api/notificationSettingsKeys";

const STALE_TIME_MS = 60_000;

export const useNotificationSettingsQuery = (): UseQueryResult<
	SettingsResponseDTO | null,
	Error
> => {
	// Users without the right must not trigger the settings request at all.
	// Outside RightsProvider the right reads false, so the query stays disabled
	// (isPending then remains true forever).
	const hasNotificationCenterRight = useNotificationCenterRightOptional();

	return useQuery({
		queryKey: NotificationSettingsKeys.settings(),
		// 404 = user not eligible for the notification center settings.
		queryFn: processResponseQuery(() => getNotificationCenterSettingsV2(), {
			nullOn404: true,
		}),
		staleTime: STALE_TIME_MS,
		enabled: hasNotificationCenterRight,
	});
};
